var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgFormUser = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#c1c1c1;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,0H25V25H0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M12.5,6.125A2.125,2.125,0,1,1,10.375,8.25,2.131,2.131,0,0,1,12.5,6.125m0,9.563c2.869,0,6.162,1.371,6.375,2.125v1.063H6.125V17.823c.213-.765,3.506-2.136,6.375-2.136M12.5,4a4.25,4.25,0,1,0,4.25,4.25A4.249,4.249,0,0,0,12.5,4Zm0,9.563c-2.837,0-8.5,1.424-8.5,4.25V21H21V17.813C21,14.986,15.337,13.563,12.5,13.563Z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFormUser, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/form-user.87952f8f.svg";
export { ForwardRef as ReactComponent };